import React from 'react'
import Alert from 'react-bootstrap/Alert';
import './customAlert.css'

export const CustomAlert = ({toShow, text, color}) => {

  //console.log('customAlert props: ', toShow, text, color)
    return (
        <Alert variant={color} className={`${toShow ? 'd-flex' : 'd-none'} m-2 mb-0 custom-alert-style`}>
          {/* <Alert.Heading>Hey, nice to see you</Alert.Heading> */}
          <p className='m-0 text-center'>
          {text}
          </p>

        </Alert>
      );
}



